<template>
    <div class="controller">
        <div class="centerStructure">
            <div id="GDmap"></div>
            <div class="fixFloor">
                <div class="mapTree" v-show="isAdmin">
                    <tree
                        ref="tree"
                        title="客户信息"
                        placeholder="请输入客户名称"
                        :treeEdit="false"
                        :headerShow="false"
                        :showCheckbox="false"
                        :sourceData="sourceData"
                        :formatTreeData="jsonTree"
                        :defExpandNode="['']"
                        @clickTreeNode="clickTree"
                        @freshTreeData="getTreeData">
                    </tree>
                </div>
                <div class="typeBox" :style="{width:typeW}">
                    <el-checkbox-group v-model="checkedType" :min="1">
                        <el-checkbox v-for="type in typeList" :label="type.id" :key="type.id" @change="oneCheckChange(type)">
                            <img class="img_icon" :src="imgobj['url' + type.id]" :alt="type.id">
                            {{type.label}} ({{type.count}})
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <div class="listIcon" ref="fix" @click.stop="clickBox">
                <div style="padding-right:10px;">
                    <el-input ref="fixInput" v-model.trim="inpval" placeholder="设备名称、表号检索" clearable 
                        suffix-icon='iconfont icon-search'>
                    </el-input>
                </div>
                <ul class="searchLoading" v-show="hasData">
                    <li v-for="item in searchData"  @click="clickItem([item.longitude,item.latitude],'markP'+item.deviceId)">
                        <div>
                            <img class="listimg" :src="imgobj['url'+item.deviceTypeId]" :alt="item.deviceId">
                            <span>{{item.deviceName}}</span>
                        </div>
                        <div>{{item.address}}</div>
                    </li>
                </ul>
                <p class="nodata" v-show="!hasData">暂无数据</p>
            </div>
        </div>
    </div>
</template>

<script>
import url_1 from '@/assets/image/home/controller/type_icon1.png'
import url_1_1 from '@/assets/image/home/controller/type_icon1-1.png'

import AMapLoader from '@amap/amap-jsapi-loader';
import {Mixins} from '@/config/mixins/mixins'
import {$http,$httpForList} from '@/config/api/axios'
import { mapGetters } from 'vuex'
import { get_session_cache } from "@/config/cache/cache.js"
import Tree from "@/components/common/Tree";
    export default {
        name: 'controller',
        mixins: [Mixins],
        components:{
            Tree,
        },
        data() {
            return{
                // checkbox
                typeList:[],
                checkedType:[1],
                checkedOnly:'',
                // 搜索
                inpval:'',
                firstOpenSearch:true,
                // tree
                sourceData:[],
                jsonTree: {
                    id: "id",
                    label: 'name',
                    pcode: 'parentCode',
                    code: 'code',
                    nodetype:'type',
                    extra:['latitude','longitude']
                },
                nodeId:'',
                //gdmap
                treeCenter:[],
                mapIntance:'', // 地图实例
                AMap:'', // then的参数
                marker:'',
                imgobj:{
                    url1:'',
                    url2:require('@/assets/image/home/controller/type_icon2.png'),
                    url3:require('@/assets/image/home/controller/type_icon3.png'),
                    url4:require('@/assets/image/home/controller/type_icon4.png'),
                    url5:require('@/assets/image/home/controller/type_icon5.png'),
                },
                searchData:[],
                searchDebounce:'',
                resData:[],
                markers:[],
                infoWindow:'',
                lngStable:[],
                gdMap:new Map(),
                // 样式相关字段
                typeW:'calc(100% - 510px)',
                isAdmin:true,
                hasData:false,
                loading1:true,
                loading2:true,
                loading3:true,
            }
        },
        computed: {
            ...mapGetters('Home', [
                'globalTheme'
            ]),
            loadingShow() {
                let flag;
                if (this.loading1 && this.loading2 && this.loading3) {
                    flag = 'hide';
                } else {
                    flag = 'show';
                }
                return flag;
            }
        },
        watch:{
            inpval(){
                this.searchDebounce();
            },
            globalTheme(theme){
                if(theme === 'theme1'){
                    this.mapIntance.setMapStyle('amap://styles/normal');
                    this.imgobj.url1 = url_1_1;
                }else{
                    this.mapIntance.setMapStyle('amap://styles/0e1141547bf9461c3d8ce9ad0fe21f8d');
                    this.imgobj.url1 = url_1;
                }
                this.mapIntance.remove(this.markers); // 为了切换主题后marks图标变色
                this.setMapMarkers(this.AMap);
            },
            loadingShow(loading) {
                loading === 'show' ? this.selfLoadingOpen('.controller') : this.selfLoadingClose();
            }
        },
        methods:{
            getTreeData() {
                $http("get", "/console/getCustomerTree").then((res) => {
                    if (res.status === 'SUCCESS') {
                        res.data.forEach(item=>{
                            if(item.id === ""){
                                item.type = 1007;
                            }else{
                                item.type = 1008;
                            }
                        })
                        this.sourceData = Object.freeze(res.data);
                        this.$nextTick(()=>{
                            this.nodeId = this.$refs.tree.treeData[0].id;
                            this.$refs.tree.setCurrentKey('');
                            this.getDeviceCount()
                            this.treeCenter = [118.189429, 39.65441]; // 所有客户节点时要求定位到唐山
                            this.mapIntance.setCenter(this.treeCenter,false,300);
                            this.mapIntance.setZoom(6)
                        })
                    } else {
                        this.sourceData = [];
                    }
                });
            },
            clickTree(data) {
                this.nodeId = data.id;
                this.treeCenter = [data.extra.longitude,data.extra.latitude];
                if(!!this.treeCenter[0]){
                    this.mapIntance.setCenter(this.treeCenter,false,300);
                    this.mapIntance.setZoom(12)
                }else{
                    if(data.id == ''){ // 单点击切换到根节点时
                        this.mapIntance.setCenter([118.156809,39.688849],false,300);
                    }
                }
                this.infoWindow.close()
                this.getDeviceCount() // 切换客户重新请求表数据
                this.$refs.fix.style.height = "60px"; // 收缩
                this.firstOpenSearch = true; // 搜索框查询列表重置
            },
            getDeviceCount(){
                this.loading2 = false;
                $http("get", "console/getCountForDeviceType",{customerId:this.nodeId}).then((res) => {
                    this.loading2 = true;
                    this.typeList = [];
                    if (res.status === 'SUCCESS') {
                        res.data.forEach(item=>{
                            this.typeList.push(
                                {label:item.deviceType,id:item.deviceTypeId,count:item.count}
                            )
                        })
                        this.getDevicePosition();
                        if(!this.isAdmin && !!this.nodeId){
                            this.getCustomerLoc();
                        }
                    } else {
                        if(res.status === "ERROR"){
                            this.msgwarning(res.message);
                        }
                    }
                });
            },
            getDevicePosition() {
                let params = {}
                let consoleVo = {};
                consoleVo.customerId = this.nodeId;
                consoleVo.deviceTypeIdList = this.checkedType;
                consoleVo.keyWord = this.inpval;
                params.consoleVo = consoleVo
                this.loading3 = false;
                $httpForList("post", "console/getDevicePosition", params)
                .then((res) => {
                    this.loading3 = true;
                    if (res.status === 'SUCCESS') {
                        this.resData = Object.freeze(res.data)
                        if(!!this.mapIntance){
                            this.mapIntance.remove(this.markers);
                            this.setMapMarkers(this.AMap);
                            this.setMapWinInfo(this.AMap);
                        }
                    } else {
                        if(!!this.mapIntance){
                            this.mapIntance.remove(this.markers);
                        }
                        if (res.status === "ERROR") {
                            this.msgwarning(res.message)
                        }
                    }
                });
            },
            oneCheckChange(item){
                if(item.count === 0){
                    return
                }
                this.getDevicePosition();
                this.firstOpenSearch = true;
                this.infoWindow.close();
            },
            clickBox(e){
                this.$refs.fix.style.height = "320px"; // 展开
                if(this.firstOpenSearch){
                    this.firstOpenSearch = false;
                    this.searchMeter();
                }
            },
            clickItem(pos,markId){
                // this.mapIntance.add(this.markers[1])
                let winInfo = this.gdMap.get(markId);
                this.infoWindow.setContent(winInfo)
                this.infoWindow.open(this.mapIntance, pos);
                this.mapIntance.setCenter(pos,false,300);
            },
            searchMeter(){
                let params = {}
                let consoleVo = {};
                consoleVo.customerId = this.nodeId;
                consoleVo.deviceTypeIdList = this.checkedType;
                consoleVo.keyWord = this.inpval;
                params.consoleVo = consoleVo
                this.selfLoadingOpen('.listIcon');
                $httpForList("post", "console/getDevicePosition", params)
                .then((res) => {
                    this.selfLoadingClose();
                    setTimeout(()=>{
                        let masks = document.querySelectorAll('.el-loading-mask');
                        masks.forEach(item=>{
                            item.style.display = "none";
                        })
                    },300)
                    if (res.status === 'SUCCESS') {
                        this.searchData = Object.freeze(res.data)
                        this.hasData = true;
                    } else {
                        this.searchData = [];
                        this.hasData = false;
                        if (res.status === "ERROR") {
                            this.msgwarning(res.message)
                        }
                    }
                });
            },
            markerClick(e){
                let markId = e.target._originOpts.extData;
                let winInfo = this.gdMap.get(markId);
                this.infoWindow.setContent(winInfo)
                this.infoWindow.open(this.mapIntance, e.target._position);
                this.mapIntance.setCenter(e.target._position,false,300);
            },
            setMapMarkers(AMap){
                this.markers = [];
                this.resData.forEach(item => {
                    let marker = new AMap.Marker({
                        offset: new AMap.Pixel(-18,-22),
                        icon:new AMap.Icon({
                            image:this.imgobj['url'+item.deviceTypeId],
                            imageSize:new AMap.Size(25,25)
                        }),
                        position:[item.longitude,item.latitude],
                        map:this.mapIntance,
                        extData:'markP'+item.deviceId,
                        markerType:item.deviceTypeId
                    })
                    marker.on('click',this.markerClick)
                    this.mapIntance.add(marker)
                    this.markers.push(marker)
                })
            },
            setMapWinInfo(AMap){
                this.resData.forEach((item,index) => {
                    let str = `<ul class="infowin">
                        <li>
                            <i></i>
                            ${item.deviceName}
                        </li>
                        <li>
                            <span>地址：</span><span>${item.address}</span>
                        </li>
                        <li>
                            <span>安装日期：</span><span>${item.installDate}</span>
                        </li>
                    </ul>`
                    this.gdMap.set('markP'+item.deviceId,str);
                })
                this.infoWindow = new AMap.InfoWindow({offset: new AMap.Pixel(-6, -25)});
            },
            mapLoading(){
                let mapStyle = this.globalTheme === 'theme1' ? 'amap://styles/normal' : 'amap://styles/0e1141547bf9461c3d8ce9ad0fe21f8d';
                this.imgobj.url1 = this.globalTheme === 'theme1' ? url_1_1 : url_1; 
                AMapLoader.load({
                    key: '27f468aa704a39be18f457d04c0b501b',//首次load必填
                    version: '2.0',
                    plugins: []
                }).then((AMap)=>{
                    this.AMap = AMap;
                    this.mapIntance = new AMap.Map('GDmap',{
                        resizeEnable: true,
                        center: [118.189429, 39.65441],
                        zoom: 12,
                        mapStyle
                    })
                    let vm = this;
                    this.mapIntance.on('complete',function(){
                        if(vm.isAdmin){
                            vm.getTreeData()
                        }else{
                            if(vm.nodeId != '' && vm.nodeId != undefined){
                                vm.getDeviceCount();
                            }
                        }
                    })
                }).catch(e=>{
                })
            },
            getCustomerLoc(){
                $http('get','/console/getPositionByCustomerId',{customerId:this.nodeId}).then(res=>{
                    if(res.status === "SUCCESS"){
                        if(!!res.data){
                            this.mapIntance.setCenter([res.data.longitude,res.data.latitude],false,300);
                        }
                    }
                })
            },
        },
        mounted() {
            this.mapLoading()
            document.onclick=(event)=>{
                this.$refs.fix.style.height = "60px";
            }
        },
        created(){
            const loginType = get_session_cache('loginType');
            this.isAdmin = loginType === "1008001" ? true : false;
            this.typeW = this.isAdmin ? 'calc(100% - 510px)' : 'calc(100% - 260px)';
            if(loginType === "1008002"){ //运维
                const loginId = get_session_cache('loginId');
                if(!!localStorage.getItem('consumer_'+loginId)){
                    this.nodeId = JSON.parse(localStorage.getItem('consumer_'+loginId)).userId;
                }
            }else if(!this.isAdmin){ // 客户
                this.nodeId = JSON.parse(localStorage.getItem('tokenUser')).tokenUserCustomerId;
            }
            this.searchDebounce = this.debounce(this.searchMeter);
        },
        destroyed(){
            document.onclick = null;
        }
    }
</script>

<style lang="less">
.controller {
    position: relative;
    width: 100%;
    height: 100%;
    margin-bottom: 10px;
    display: flex;
    .tree-box{
        .overauto{
            &::-webkit-scrollbar{
                width: 4px;
                height: 4px;
            }
        }
    }
    .centerStructure {
        position: relative;
        padding: 0;
        .listIcon{
            position: absolute;
            top: 10px;
            right: 10px;
            z-index: 999;
            width: 230px;
            height: 60px;
            overflow: hidden;
            border-radius:5px;
            border: 1px solid rgba(0,92,155,.6);
            box-shadow: 0px 0px 5px rgba(0,50,91,.6);
            padding: 13px 10px 15px 20px;
            background: rgba(0,50,91,.6);
            transition: height .5s;
            color: #fff;
            .el-input{
                margin-bottom: 13px;
                .el-input__inner{
                    background: rgba(0,50,91,1);
                    border: 1px solid rgba(0,92,155,.6);
                    color: #fff;
                }
            }
            ul{
                height: 250px;
                overflow-y: auto;
                overflow-x: hidden;
                padding-right: 10px;
                li{
                    &:hover{
                        background: rgba(0,167,210,0.3);
                    }
                    cursor: pointer;
                    height: 54px;
                    border-bottom:1px solid rgba(0,92,155,.6);
                    div{
                        &:nth-child(1){
                            margin-top: 8px;
                        }
                        &:nth-child(2){
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        span{
                            vertical-align: 2px;
                        }
                    }
                    .listimg{
                        display: inline-block;
                        width: 15px;
                        height: 15px;
                        margin-right: 14px;
                    }
                }
                &::-webkit-scrollbar{
                    width: 4px;
                    height: 4px;
                }
                &::-webkit-scrollbar-thumb{
                    border-radius: 10px;
                    box-shadow: inset 0 0 5px rgba(0,154,193, 0.4);
                    background: rgba(0,154,193, 0.4);
                }
                &::-webkit-scrollbar-track{
                    box-shadow: inset 0 0 5px rgba(24,25,27, 0.1);
                    background: rgba(24,25,27, 0.1);
                    border-radius: 0;
                }
            }
            .nodata{
                margin-left: 66px;
                margin-top: 50%;
            }
        }
        #GDmap{
            width: 100%;
            height: 100%;
            z-index: 9;
            .amap-icon{
                >img{
                    height: 20px;
                    width: 20px;
                }
            }
            .amap-marker{
                img{
                    width: 16px;
                    height: 20px;
                }
            }
        }
    }
    .fixFloor{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
        height: 0px;
        width: 100%;
        .mapTree{
            height: 450px;
            width: 240px;
            float: left;
            background: rgba(0,50,91,.6);
            margin-top: 10px;
            margin-left: 10px;
            padding-top: 15px;
            .tree-box .overauto{
                height: 400px;
            }
        }
        .typeBox{
            height: 60px;
            background: rgba(0,50,91,.6);
            float: left;
            margin-top: 10px;
            margin-left: 10px;
            line-height: 60px;
            padding-left: 20px;
            .el-checkbox{
                margin-right: 50px;
            }
            .el-checkbox__label{
                font-size: 16px;
            }
            .img_icon{
                display: inline-block;
                width: 20px;
                vertical-align:-4px;
            }
        }
    }
}
.amap-info-content{
    border-radius: 5px;
    width: auto;
    overflow-x: hidden;
    padding: 0;
}
.bottom-center .amap-info-sharp{
    position: absolute;
    bottom: 3px;
    left: 50%;
    margin-left: -7px;
    width: 13px;
    height: 13px;
    clip-path: polygon(50% 50%, 100% 0, 100% 100%, 0% 100%);
    transform:rotate(45deg);
}
.infowin{
    padding: 10px 20px 14px 20px;
    li{
        display: flex;
        line-height: 1.6;
        margin: 0 auto;
        &:nth-child(1){
            width: 100%;
            display: block;
            font-weight: bold;
            font-size: 15px;
            line-height: 2.2;
            i{
                display: inline-block;
                width: 5px;
                height: 16px;
                background:#4980d7;
                
                vertical-align: -2px;
                margin-right: 5px;
            }
        }
        span{
            display: inline-block;
            font-size: 13px;
            white-space: nowrap;
            &:nth-child(1){
                min-width: 65px;
            }
        }
    }
}
.theme2 .amap-info-content{
    background: rgba(0,50,91,.5);
    box-shadow: 4px 4px 3px #092551;
    border: 1px solid rgba(0,92,155,.6);
}
.theme2 .bottom-center .amap-info-sharp{
    background: #0a2946;
    border:1px solid rgba(0,92,155,.6);
}
.theme2 .infowin li{
    color: #fff;
}
.theme2 .fixFloor .el-input__inner, 
.theme2 .fixFloor .el-textarea__inner{
    background: rgba(0,50,91,1);
    border: 1px solid rgba(0,92,155,.6);
    color: #fff;
}
.theme2 .controller .el-input__prefix, 
.theme2 .controller .el-input__suffix{
    color: #83B2C6;
}
.theme2 .controller .fixFloor .el-tree{
    color: #fff;
}
.theme2 .controller input::-webkit-input-placeholder{
    color: #83B2C6;
}
.theme2 .fixFloor .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
    background-color:#001D33;
}
.theme2 .controller .fixFloor .el-tree-node__content:hover{
    background: rgba(255,255,255,.1);
}
.theme2 .controller .el-tree-node:focus>.el-tree-node__content{
    background:none;
}
.theme2 .controller .el-checkbox__input.is-checked .el-checkbox__inner, 
.theme2 .controller .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background: none;
    border-color:#00EDFF;
}
.theme2{
    .controller{
        .fixFloor{
            .mapTree,.typeBox{
                border: 1px solid rgba(0,92,155,.6);
            }
        }
        .tree-box{
            .overauto{
                width: 238px;
                &::-webkit-scrollbar-thumb{
                    border-radius: 10px;
                    box-shadow: inset 0 0 5px rgba(0,154,193, 0.4);
                    background: rgba(0,154,193, 0.4);
                }
                &::-webkit-scrollbar-track{
                    box-shadow: inset 0 0 5px rgba(24,25,27, 0.1);
                    background: rgba(24,25,27, 0.1);
                    border-radius: 0;
                }
                &::-webkit-scrollbar-corner{
                    background-color: rgba(0,0,0,.2);
                }
            }
            .treeIcon .iconfont{
                color:#83B2C6;
            }
        }
        .el-checkbox{
            color: #fff;
        }
        .el-checkbox__inner{
            background: rgba(0,50,91,.6);
            border-color: #008ebf;
            &:hover{
                border-color:'#00EDFF';
            }
            &::after{
                border-color:#00EDFF;
            }
        }
        .el-checkbox__input.is-checked+.el-checkbox__label{
            color: #fff;
        }
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color: #00EDFF;
    }
    .el-input .el-input__clear{
        color: #83B2C6;
    }
    .infowin li:nth-child(1) i{
        background: rgba(0,92,155,.6);
    }
}
.theme1{
    .controller{
        .fixFloor{
            .typeBox{
                background: #fff;
                box-shadow: 0px 0px 3px rgba(68, 48, 96, 0.2);
                border-radius: 5px;
            }
            .mapTree{
                background: #fff;
                box-shadow: 0px 0px 3px rgba(68, 48, 96, 0.2);
                border-radius: 5px;
            }
        }
        // 搜索框样式
        .centerStructure .listIcon{
            padding-top: 15px;
            border: none;
            background: #fff;
            color:#606266;
            box-shadow: 0px 0px 3px rgba(68, 48, 96, 0.2);
            ul li{
                border-bottom: 1px solid #DCDFE6;
                &:hover{
                    color: #4980d7;
                    background: #f0f4ff;
                }
            }
            ul{
                &::-webkit-scrollbar-thumb{
                    border-radius: 10px;
                    box-shadow: inset 0 0 5px rgba(24,25,27, 0.2);
                    background: rgba(24,25,27, 0.2);
                }
            }
            .el-input .el-input__inner{
                background: #fff;
                border: 1px solid #DCDFE6;
                color: #606266;
            }
            
        }
        .el-checkbox__input.is-disabled+span.el-checkbox__label,
        .el-checkbox__input.is-checked+.el-checkbox__label{
            color:#606266;
        }
        .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner{
            background: #fff !important;
            border-color: #4980d7;
            &::after{
                border-color:#4980d7;
            }
        }
        .el-checkbox__inner{
            background: #fff !important;
            border-color: #4980d7;
            &:hover{
                border-color:'#4980d7';
            }
            &::after{
                border-color:#4980d7;
            }
        }
    }
    .amap-info-content{
        border: 1px solid #F2F2F2;
        box-shadow: 4px 4px 3px #999999;
        background: rgba(255, 255, 255, .85);
    }
    .bottom-center .amap-info-sharp{
        background: rgba(255, 255, 255, .85);
        border:1px solid #fff;
    }
}
</style>
